export interface HeaderLinks {
  homeURL: string;
  plansURL: string;
  personalDetailsURL: string;
  salesURL: string;
}
